import { API_CONFIG } from '@/config/api';
import { httpClient } from '@/utils/httpClient';

export type CatalogAdjustmentScope = 'available_only' | 'assigned_only' | 'both';

export interface CatalogAdjustmentRequest {
  catalogId: string;
  lin: string;
  nsn: string;
  nomenclature: string;
  scope: CatalogAdjustmentScope;
  note?: string;
  justification?: string;
}

export interface CatalogAdjustmentResponse {
  catalogId: string;
  updatedAt: string;
  scope: CatalogAdjustmentScope;
  summary: {
    catalogUpdated: boolean;
    updatedAvailableAssetCount: number;
    updatedAssignedAssetCount: number;
    updatedTotalAssetCount: number;
  };
  transactionLogId?: string;
  da4949GeneratedDocumentId?: string;
  da4949DocumentEntityId?: string;
  da4949DocumentNumber?: string | null;
}

class CatalogAdjustmentService {
  private endpoint = API_CONFIG.ENDPOINTS.CATALOG_4949_ADJUSTMENT;

  async applyAdjustment(payload: CatalogAdjustmentRequest): Promise<CatalogAdjustmentResponse> {
    return httpClient.post<CatalogAdjustmentResponse>(this.endpoint, payload);
  }
}

export const catalogAdjustmentService = new CatalogAdjustmentService();
